export const menus = [
	{ is_header: true, title: "Navegación Principal" },
	{ path: "/dashboard", icon: "bi bi-house", title: "Inicio" },
	{ path: "/tournaments", icon: "bi bi-trophy-fill", title: "Torneos" },
	{ path: "/participants", icon: "bi bi-people", title: "Participantes" },
];
